export const NUM_ARCHIVES_PER_ROW = {
  xs: 1,
  sm: 3,
  md: 4,
  lg: 5,
  xl: 8,
};

export const NUM_ARCHIVES_FOR_RENDER = {
  xs: 15,
  sm: 15,
  md: 20,
  lg: 25,
  xl: 40,
};

export const GENERAL_TAG_TYPE = "other/misc";
